import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { Box } from '@piconetworks/ui'

const EmptyComponent = ({ children, className }) => (
    <Box.Flexbox.Container justifyContent='center' className={cx(className)}>
        {children}
    </Box.Flexbox.Container>
)

EmptyComponent.propTypes = {
    children: PropTypes.node,
    className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
}

export default EmptyComponent
